<!--
  ─────────────────────────────────────────────────────────────────────────────
  components/LiveVerbindungHinweis.vue — DER SICHTBARE VERBINDUNGSZUSTAND
  (T-M21.5, REQ-OPS-054 (a) bis (e); REQ-OPS-034, REQ-PS-023a, REQ-OV-002/005)

  ── WOFUER ─────────────────────────────────────────────────────────────────
  Der Felddefekt vom 2026-08-17/18, woertlich aus der Meldung: „das Frontend
  merkt nicht, dass es keine Verbindung mehr hat". Mit T-M21.4 SAGEN die Stores
  jetzt die Wahrheit ueber sich (`error` gesetzt, `isSubscribed`
  zurueckgenommen) — nur SAH man es nirgends. Diese Datei ist der eine Ort, an
  dem der Rahmen der Verwaltungsoberflaeche es zeigt: **was nicht mehr live ist,
  sieht nicht mehr live aus.**

  ── WAS ER SAGT, UND WAS ER AUSDRUECKLICH NICHT SAGT ───────────────────────
    • Er NENNT die betroffenen Bereiche (Druckauftraege, Drucker, Printserver,
      Firmen, …) und nicht bloss „Fehler" (REQ-OPS-054 (b)).
    • Er ZEIGT KEINEN ZEITPUNKT. Ein „zuletzt aktualisiert", das aus der Uhr
      des Geraets gebildet waere, sagte nichts ueber die Daten aus — der
      Zeitpunkt der letzten empfangenen Momentaufnahme wird NIRGENDS gefuehrt.
      Ein erfundener Zeitpunkt waere dieselbe Falschaussage wie eine stehende
      Live-Sicht, nur mit Uhrzeit (REQ-OPS-054 (b), REQ-OPS-034).
    • Er LAEDT NICHTS NEU (REQ-OPS-054 (d)). Es gibt genau eine Handlung, und
      sie wird vom Bediener ausgeloest.
    • Er ist KEINE NETZDIAGNOSE (REQ-OPS-054 (e)). Er spricht ueber die Abos
      DIESER Sitzung: „nicht mehr live" heisst hier „dieses Abo liefert nichts
      mehr" — nicht „das Geraet ist offline".

  ── WORAUS ER SEINEN ZUSTAND LIEST — samt der benannten Luecke ─────────────
  Gelesen wird je Store das Paar `error` UND `isSubscribed`:

      nicht mehr live  :=  error ist gesetzt  UND  isSubscribed ist false

  Die Konjunktion ist tragend und nicht Zierde:
    • `isSubscribed === false` allein waere jeder Store, der nie abonniert hat;
    • `error !== null` allein waere auch der Store, dessen Abo LEBT und bei dem
      nur eine Schreibhandlung fehlschlug (`printJobStore.createJob`) oder ein
      NEBENabo starb (`companyStore` fuehrt EINE Meldung fuer Firmen und
      Mitglieder). Beide Faelle sind hier ausdruecklich still.

  **DIE LUECKE, benannt (Stand 2026-08-18):** kein Store haelt fest, ob die
  Rueckzugsstaffel noch LAEUFT oder schon ERSCHOEPFT ist. Die Bildungsstelle
  reicht die Lage (`versuch`, `wirdWiederaufgenommen`, `delayMs`) an den
  Fehlerweg durch — die Stores verwerfen sie. Aus dem Store allein sind die
  beiden Faelle deshalb NICHT unterscheidbar, und diese Ansicht darf sie ohne
  Store-Aenderung nicht erfinden.

  Daraus folgt die Bauform der zwei Lautstaerken (REQ-OPS-054 (c)):
    • **leise**, solange die Staffel rechnerisch noch laufen KANN — also bis
      zur Summe der Staffel (2+4+8+16+30 s) nach dem ersten Auftreten des
      Fehlzustands. Die Summe wird aus `RUECKZUGSSTAFFEL_MS` GERECHNET und
      nicht als zweite Zahl gefuehrt;
    • **laut** danach: dauerhaft sichtbarer Hinweis mit der Handlung
      „Erneut verbinden" (REQ-OPS-054 (a)).
  **Der Zeitgeber steuert allein die AUFFAELLIGKEIT, nie eine Aussage.** Beide
  Fassungen sagen dasselbe Wahre („X ist nicht mehr live"); keine behauptet,
  die Staffel sei erschoepft, und keine verspricht eine Wiederaufnahme.
  *Sobald ein Store den erschoepften Zustand selbst fuehrt, ersetzt er hier den
  Zeitgeber — die Ansicht bliebe im Uebrigen unveraendert.*

  **Benannte Folge dieser Naeherung:** montiert der Rahmen NEU, waehrend ein
  Fehlzustand bereits steht (Neuladen der Seite), laeuft die leise Stufe noch
  einmal — die Ansicht kennt das Alter des Fehlers nicht und erfindet es nicht.

  ── DIE HANDLUNG (REQ-PS-023a: kein Bedienelement ohne Wirkung) ────────────
  „Erneut verbinden" ruft `subscribe(...)` NUR auf den betroffenen Stores, mit
  den gefuehrten Parametern: der Mandant kommt aus `companyStore
  .selectedCompanyId` — der einzigen Mandantenangabe, die der Rahmen fuehrt.
  Der beim Abo verwendete Mandant selbst ist nach dem Fehler nicht mehr
  abzulesen (`subscribedCompanyId` faellt im Fehlerweg auf `null`). Ein Abo auf
  einen FREMDEN Mandanten kann daraus nicht entstehen; hoechstens eine engere
  Sicht als zuvor (die filterlose Druckserver-Liste einiger Ansichten wird auf
  den gewaehlten Mandanten verengt), und die stellt die Ansicht beim naechsten
  Betreten selbst wieder her.

  ⚠ NACHTRAG 2026-09-10 (T-M35.2 Nacharbeit N1, REQ-SEC-029 (e) Praez. 1,
  REQ-OPS-054 (a); berichtigt statt geloescht, REQ-OPS-036 Praez. 6): **fuer die
  DRUCKSERVER gilt der Absatz oben nicht mehr.** „Hoechstens eine engere Sicht,
  die die Ansicht beim naechsten Betreten selbst wiederherstellt" war die
  Abwaegung, solange dieser Store genau EINE Reichweite hatte. Seit dem
  2026-09-10 hat er zwei (mandantengebunden und — nur fuer einen Admin unter
  `/settings/printserver` — mandantenuebergreifend); die Verengung waere dort
  kein Randfall mehr, sondern eine stille Falschanzeige der Flotte, und ohne
  gewaehlten Mandanten naehme der Knopf gar nichts wieder auf. **Dieser eine
  Bereich uebergibt deshalb keine Kennung mehr, sondern ruft den Rueckweg des
  Stores** (`erneutAbonnieren`), der das zuletzt LAUFENDE Abo wieder aufnimmt.
  Fuer alle uebrigen Bereiche bleibt der Absatz oben in Kraft — sie haben je
  genau eine Reichweite.

  ── WAS HIER NICHT GEFUEHRT WIRD, und warum ────────────────────────────────
  Die Mitglieder-Liste eines Mandanten (`companyStore.subscribeMembers`) fehlt
  in der Aufstellung: sie haengt an der Firma der geoeffneten DETAILSEITE und
  nicht am gewaehlten Mandanten. Der Rahmen kennt diese Kennung nicht — er
  koennte sie nur RATEN, und ein Knopf, der die falsche Firma abonniert, waere
  schlechter als keiner.
  ─────────────────────────────────────────────────────────────────────────────
-->
<template>
  <div
    v-if="betroffene.length > 0"
    class="live-hinweis"
    :class="laut ? 'live-hinweis-laut' : 'live-hinweis-leise'"
    :role="laut ? 'alert' : 'status'"
  >
    <template v-if="laut">
      <div class="live-hinweis-text">
        <strong class="live-hinweis-titel">{{ t('liveVerbindung.title') }}</strong>
        <span class="live-hinweis-bereiche">{{ t('liveVerbindung.areas', { areas: bereichsnamen }) }}</span>
        <span class="live-hinweis-folge">{{ t('liveVerbindung.hint') }}</span>
      </div>
      <button type="button" class="live-hinweis-btn" @click="erneutVerbinden">
        {{ t('liveVerbindung.reconnect') }}
      </button>
    </template>

    <!-- Die leise Stufe: eine Zeile, kein Banner, keine Handlung (REQ-OPS-054 (c)). -->
    <span v-else class="live-hinweis-still">
      {{ t('liveVerbindung.quiet', { areas: bereichsnamen }) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { RUECKZUGSSTAFFEL_MS } from '@/utils/liveAbo';
import { useApiTokenStore }    from '@/stores/apiTokenStore';
import { useCompanyStore }     from '@/stores/companyStore';
import { useLocationStore }    from '@/stores/locationStore';
import { usePrinterStore }     from '@/stores/printerStore';
import { usePrintJobStore }    from '@/stores/printJobStore';
import { usePrintserverStore } from '@/stores/printserverStore';
import { useRegisterStore }    from '@/stores/registerStore';
import { useUserStore }        from '@/stores/userStore';

const { t } = useI18n();

const apiTokenStore    = useApiTokenStore();
const companyStore     = useCompanyStore();
const locationStore    = useLocationStore();
const printerStore     = usePrinterStore();
const printJobStore    = usePrintJobStore();
const printserverStore = usePrintserverStore();
const registerStore    = useRegisterStore();
const userStore        = useUserStore();

/**
 * Ein Bereich der Verwaltung, so weit er hier vorkommt: ein Name fuer den
 * Bediener, die Frage „lebt das Abo noch?" und der Weg zurueck.
 */
interface Bereich {
  /** Schluessel unter `liveVerbindung.area.*` — der Name kommt aus `vue-i18n`. */
  key: string;
  /** Fehlzustand nach REQ-OPS-053 (a) (ii): Meldung gesetzt UND Abo tot. */
  tot: () => boolean;
  /** Wiederaufnahme mit den gefuehrten Parametern (REQ-PS-023a). */
  erneut: (companyId: string | null) => void;
}

/**
 * Die Aufstellung. Die REIHENFOLGE ist die der Aufzaehlung im Hinweis und
 * damit fest — ein Text, der bei jedem Bild anders sortiert ist, liest sich
 * wie eine Veraenderung, wo keine ist.
 */
const bereiche: Bereich[] = [
  {
    key: 'jobs',
    tot: () => !!printJobStore.error && !printJobStore.isSubscribed,
    erneut: (c) => { if (c) printJobStore.subscribe(c); },
  },
  {
    key: 'printers',
    tot: () => !!printerStore.error && !printerStore.isSubscribed,
    erneut: (c) => printerStore.subscribe(c ?? undefined),
  },
  {
    key: 'printservers',
    tot: () => !!printserverStore.error && !printserverStore.isSubscribed,
    // ⚠ OHNE MANDANT KEIN NEUABONNIEREN (T-M30.7 N1a): bis zum 2026-09-01 stand
    // hier `subscribe(c ?? undefined)` und griff damit den filterlosen Zweig,
    // den es nicht mehr gibt. Der Mandant ist Vorbedingung des Abos — dieselbe
    // Form wie bei `jobs`, `locations` und `registers` darueber.
    //
    // ⚠ NACHTRAG 2026-09-10 (T-M35.2 Nacharbeit N1, REQ-SEC-029 (e) Praez. 1,
    // REQ-OPS-054 (a); berichtigt statt geloescht, REQ-OPS-036 Praez. 6): bis
    // dahin stand hier `erneut: (c) => { if (c) printserverStore.subscribe(c); }`.
    // **Der Satz darueber gilt nur noch fuer den mandantengebundenen Weg.**
    // Seit dem 2026-09-10 hat dieser Store ZWEI Reichweiten (mandantengebunden
    // und — nur fuer einen Admin unter `/settings/printserver` —
    // mandantenuebergreifend), und der Hinweis kennt sie nicht: er kennt allein
    // den GEWAEHLTEN Mandanten. Mit dem gewaehlten Mandanten
    // wiederaufzunehmen hiesse, einem Admin die Liste still auf EINEN Mandanten
    // zu schrumpfen — und ohne gewaehlten Mandanten gar nicht wiederaufzunehmen,
    // waehrend der Hinweis zum Handeln auffordert.
    // **Wiederaufgenommen wird deshalb das Abo, das LIEF** — die Reichweite
    // gehoert dem Store (`erneutAbonnieren`), nicht dieser Aufrufstelle. Nur
    // diese eine Zeile aendert sich; die uebrigen Bereiche haben je genau eine
    // Reichweite und bleiben, wie sie sind.
    erneut: () => printserverStore.erneutAbonnieren(),
  },
  {
    key: 'companies',
    tot: () => !!companyStore.error && !companyStore.isSubscribed,
    erneut: () => companyStore.subscribe(),
  },
  {
    key: 'locations',
    tot: () => !!locationStore.error && !locationStore.isSubscribed,
    erneut: (c) => { if (c) locationStore.subscribe(c); },
  },
  {
    key: 'registers',
    tot: () => !!registerStore.error && !registerStore.isSubscribed,
    erneut: (c) => { if (c) registerStore.subscribe(c); },
  },
  {
    key: 'users',
    tot: () => !!userStore.error && !userStore.isSubscribed,
    erneut: () => userStore.subscribe(),
  },
  {
    key: 'apiTokens',
    tot: () => !!apiTokenStore.error && !apiTokenStore.isSubscribed,
    erneut: (c) => { if (c) apiTokenStore.subscribe(c); },
  },
];

/** Die Bereiche, die gerade nichts mehr liefern. */
const betroffene = computed(() => bereiche.filter(b => b.tot()));

/** Ihre Namen, wie sie im Hinweis stehen — uebersetzt, nie fest verdrahtet. */
const bereichsnamen = computed(
  () => betroffene.value.map(b => t(`liveVerbindung.area.${b.key}`)).join(', '),
);

/**
 * Die Summe der Rueckzugsstaffel: FRUEHER als nach dieser Zeit kann sie nicht
 * erschoepft sein (REQ-OPS-053 (b)). Sie wird aus der Staffel gerechnet — eine
 * zweite Zahl liefe mit ihr auseinander.
 */
const STAFFEL_GESAMT_MS = RUECKZUGSSTAFFEL_MS.reduce((summe, ms) => summe + ms, 0);

/** Laut oder leise (REQ-OPS-054 (c)) — eine Frage der Auffaelligkeit, nicht der Aussage. */
const laut = ref(false);
let uhr: ReturnType<typeof setTimeout> | null = null;

function uhrLoeschen(): void {
  if (uhr) { clearTimeout(uhr); uhr = null; }
}

watch(
  () => betroffene.value.length > 0,
  (imFehlzustand) => {
    uhrLoeschen();
    laut.value = false;
    if (!imFehlzustand) return;
    uhr = setTimeout(() => { laut.value = true; uhr = null; }, STAFFEL_GESAMT_MS);
  },
  { immediate: true },
);

// Ein stehengebliebener Zeitgeber ist ein Befund, kein Detail (REQ-OPS-034).
onUnmounted(uhrLoeschen);

/**
 * „Erneut verbinden" — die einzige Handlung, und sie WIRKT: sie nimmt genau
 * die Abos wieder auf, die der Hinweis benennt. Kein Neuladen der Seite
 * (REQ-OPS-054 (d)).
 */
function erneutVerbinden(): void {
  const companyId = companyStore.selectedCompanyId ?? null;
  // Ueber eine Kopie laufen: `subscribe()` macht `tot()` unmittelbar falsch,
  // und die Liste schruempfte sonst unter dem Durchlauf weg.
  for (const bereich of [...betroffene.value]) bereich.erneut(companyId);
}
</script>

<style scoped>
.live-hinweis {
  display:       flex;
  align-items:   center;
  gap:           16px;
  border-radius: var(--radius-md);
}

/* ── laut: der dauerhaft sichtbare Hinweis (REQ-OPS-054 (a)) ─────────────── */
.live-hinweis-laut {
  position:      sticky;
  top:           0;
  z-index:       20;
  margin:        16px 24px 0;
  padding:       14px 18px;
  background:    var(--color-surface);
  border:        1px solid var(--color-failed);
  border-left:   4px solid var(--color-failed);
  box-shadow:    var(--color-shadow);
  flex-wrap:     wrap;
}

.live-hinweis-text { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 260px; }

.live-hinweis-titel    { color: var(--text-primary); font-size: 15px; font-weight: 600; }
.live-hinweis-bereiche { color: var(--text-primary); }
.live-hinweis-folge    { color: var(--text-secondary); font-size: 13px; }

.live-hinweis-btn {
  font-family:   var(--font-sans);
  font-size:     14px;
  font-weight:   500;
  padding:       9px 16px;
  border:        1px solid transparent;
  border-radius: var(--radius-md);
  background:    var(--gradient-brand-h);
  color:         var(--text-on-brand);
  cursor:        pointer;
  transition:    box-shadow var(--t-fast);
}

.live-hinweis-btn:hover { box-shadow: var(--color-shadow-lg); }

/* ── leise: eine Zeile, kein Banner (REQ-OPS-054 (c)) ────────────────────── */
.live-hinweis-leise {
  margin:     10px 24px 0;
  padding:    4px 0;
  color:      var(--text-muted);
  font-size:  13px;
}
</style>
